var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseAlt6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.88513 7.83021C2.33189 8.20943 2 8.84503 2 9.52532V19.9582C2 21.0859 2.89543 22 4 22H8V17.9165C8 15.6612 9.79086 13.833 12 13.833C14.2091 13.833 16 15.6612 16 17.9165V22H20C21.1046 22 22 21.0859 22 19.9582V9.52532C22 8.84503 21.6681 8.20943 21.1149 7.83021L13.1149 2.34665C12.4406 1.88445 11.5594 1.88445 10.8851 2.34665L2.88513 7.83021Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseAlt6);
export default __webpack_public_path__ + "static/media/house-alt-6.bf015f44a1a719eb2801c64c325f5abb.svg";
export { ForwardRef as ReactComponent };